import React, { useState, useEffect } from 'react';
import { registrePersonnelAPI } from '../services/api';

const initialRow = () => ({
  id: undefined,
  nomPrenom: '',
  nomUsage: '',
  dateNaissance: '',
  lieuNaissance: '',
  deptPaysNaissance: '',
  nationalite: '',
  numeroSS: '',
  dateEntree: '',
  dateSortie: '',
  emploi: '',
  qualification: '',
  visitesMedicales: '',
  typeContrat: '',
  dureeContrat: '',
  salaireBase: '',
  tempsPartiel: '',
  tauxHoraire: '',
  heuresContractuelles: '',
  conventionCollective: '',
  niveauCoef: '',
  emploiEmbauche: '',
  dernierContrat: '',
  groupementEmployeurs: '',
  observations: '',
});

const RegistrePersonnel = () => {
  const [rows, setRows] = useState(() => [initialRow()]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await registrePersonnelAPI.getAll();
        const data = response.data || [];
        if (data.length > 0) {
          setRows(
            data.map((item) => ({
              id: item.id,
              nomPrenom: item.nomPrenom || '',
              nomUsage: item.nomUsage || '',
              dateNaissance: item.dateNaissance || '',
              lieuNaissance: item.lieuNaissance || '',
              deptPaysNaissance: item.deptPaysNaissance || '',
              nationalite: item.nationalite || '',
              numeroSS: item.numeroSS || '',
              dateEntree: item.dateEntree || '',
              dateSortie: item.dateSortie || '',
              emploi: item.emploi || '',
              qualification: item.qualification || '',
              visitesMedicales: item.visitesMedicales || '',
              typeContrat: item.typeContrat || '',
              dureeContrat: item.dureeContrat || '',
              salaireBase: item.salaireBase || '',
              tempsPartiel: item.tempsPartiel || '',
              tauxHoraire: item.tauxHoraire || '',
              heuresContractuelles: item.heuresContractuelles || '',
              conventionCollective: item.conventionCollective || '',
              niveauCoef: item.niveauCoef || '',
              emploiEmbauche: item.emploiEmbauche || '',
              dernierContrat: item.dernierContrat || '',
              groupementEmployeurs: item.groupementEmployeurs || '',
              observations: item.observations || '',
            }))
          );
        }
      } catch (e) {
        console.error('Erreur chargement registre personnel:', e);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const addRow = async () => {
    try {
      const payload = {
        nomPrenom: '',
      };
      const response = await registrePersonnelAPI.create(payload);
      const item = response.data;
      setRows((prev) => [
        ...prev,
        {
          id: item.id,
          nomPrenom: item.nomPrenom || '',
          nomUsage: item.nomUsage || '',
          dateNaissance: item.dateNaissance || '',
          lieuNaissance: item.lieuNaissance || '',
          deptPaysNaissance: item.deptPaysNaissance || '',
          nationalite: item.nationalite || '',
          numeroSS: item.numeroSS || '',
          dateEntree: item.dateEntree || '',
          dateSortie: item.dateSortie || '',
          emploi: item.emploi || '',
          qualification: item.qualification || '',
          visitesMedicales: item.visitesMedicales || '',
          typeContrat: item.typeContrat || '',
          dureeContrat: item.dureeContrat || '',
          salaireBase: item.salaireBase || '',
          tempsPartiel: item.tempsPartiel || '',
          tauxHoraire: item.tauxHoraire || '',
          heuresContractuelles: item.heuresContractuelles || '',
          conventionCollective: item.conventionCollective || '',
          niveauCoef: item.niveauCoef || '',
          emploiEmbauche: item.emploiEmbauche || '',
          dernierContrat: item.dernierContrat || '',
          groupementEmployeurs: item.groupementEmployeurs || '',
          observations: item.observations || '',
        },
      ]);
    } catch (e) {
      console.error('Erreur création ligne registre personnel:', e);
    }
  };

  const updateCell = async (index, field, value) => {
    setRows((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };
      return copy;
    });

    const row = rows[index];
    if (!row || !row.id) return;

    try {
      await registrePersonnelAPI.update(row.id, { [field]: value });
    } catch (e) {
      console.error('Erreur mise à jour registre personnel:', e);
    }
  };

  const deleteRow = async (index) => {
    const row = rows[index];
    setRows((prev) => prev.filter((_, i) => i !== index));

    if (!row || !row.id) return;

    try {
      await registrePersonnelAPI.delete(row.id);
    } catch (e) {
      console.error('Erreur suppression registre personnel:', e);
    }
  };

  const exportCSV = () => {
    const headers = [
      "N°",
      "Nom et prénoms",
      "Nom d'usage",
      "Date naissance",
      "Lieu naissance",
      "Dép/Pays",
      "Nationalité",
      "N° SS",
      "Date entrée",
      "Date sortie",
      "Emploi",
      "Qualification",
      "Visites médicales",
      "Type contrat",
      "Durée",
      "Salaire",
      "Temps partiel",
      "Taux horaire",
      "Heures",
      "CCN",
      "Niveau/Coef",
      "Emploi embauche",
      "Dernier contrat",
      "Groupement",
      "Observations",
    ];

    let csv = headers.join(',') + '\n';

    rows.forEach((row, index) => {
      const values = [
        String(index + 1),
        row.nomPrenom,
        row.nomUsage,
        row.dateNaissance,
        row.lieuNaissance,
        row.deptPaysNaissance,
        row.nationalite,
        row.numeroSS,
        row.dateEntree,
        row.dateSortie,
        row.emploi,
        row.qualification,
        row.visitesMedicales,
        row.typeContrat,
        row.dureeContrat,
        row.salaireBase,
        row.tempsPartiel,
        row.tauxHoraire,
        row.heuresContractuelles,
        row.conventionCollective,
        row.niveauCoef,
        row.emploiEmbauche,
        row.dernierContrat,
        row.groupementEmployeurs,
        row.observations,
      ].map((v) => `"${String(v || '').replace(/"/g, '""')}"`);

      csv += values.join(',') + '\n';
    });

    const blob = new Blob(["\ufeff" + csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const today = new Date().toISOString().slice(0, 10);
    a.download = `registre_personnel_${today}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="mx-auto w-full py-6 px-2 sm:px-4 lg:px-6">
        <h1 className="text-3xl font-bold text-center text-gray-900 mb-6">
          Registre Unique du Personnel
        </h1>
        <p className="text-center text-sm text-gray-600 mb-4">
          Version simplifi&eacute;e num&eacute;rique &ndash; Export CSV conforme au registre officiel 2025.
        </p>

        <div className="bg-white shadow-xl rounded-lg overflow-hidden border border-gray-200">
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse text-[11px]">
              <thead>
                <tr className="bg-green-700 text-white text-[11px]">
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">N°</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Nom et prénoms</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Nom d&apos;usage</th>
                  <th colSpan={3} className="border border-green-800 px-2 py-1">Naissance</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Nationalité</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">N° SS</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Date entrée</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Date sortie</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Emploi</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Qualification professionnelle</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Dates et nature visites médicales</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Type de contrat</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Durée (si CDD)</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Salaire de base</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Temps partiel</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Taux horaire</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Nb heures contractuelles</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Convention collective</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Niveau / Coef. / Échelon</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Emploi &agrave; l&apos;embauche</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Dernier contrat</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Groupement d&apos;employeurs</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">Observations</th>
                  <th rowSpan={2} className="border border-green-800 px-2 py-1">✖</th>
                </tr>
                <tr className="bg-green-700 text-white text-[11px]">
                  <th className="border border-green-800 px-2 py-1">Date</th>
                  <th className="border border-green-800 px-2 py-1">Lieu</th>
                  <th className="border border-green-800 px-2 py-1">Dép./Pays</th>
                </tr>
              </thead>
              <tbody className="text-[11px]">
                {rows.map((row, index) => (
                  <tr key={index} className="hover:bg-gray-50 border-b">
                    <td className="border px-1 text-center font-semibold">{index + 1}</td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.nomPrenom}
                        onChange={(e) => updateCell(index, 'nomPrenom', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.nomUsage}
                        onChange={(e) => updateCell(index, 'nomUsage', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="date"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.dateNaissance}
                        onChange={(e) => updateCell(index, 'dateNaissance', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.lieuNaissance}
                        onChange={(e) => updateCell(index, 'lieuNaissance', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.deptPaysNaissance}
                        onChange={(e) => updateCell(index, 'deptPaysNaissance', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.nationalite}
                        onChange={(e) => updateCell(index, 'nationalite', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.numeroSS}
                        onChange={(e) => updateCell(index, 'numeroSS', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="date"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.dateEntree}
                        onChange={(e) => updateCell(index, 'dateEntree', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="date"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.dateSortie}
                        onChange={(e) => updateCell(index, 'dateSortie', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.emploi}
                        onChange={(e) => updateCell(index, 'emploi', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.qualification}
                        onChange={(e) => updateCell(index, 'qualification', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.visitesMedicales}
                        onChange={(e) => updateCell(index, 'visitesMedicales', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.typeContrat}
                        onChange={(e) => updateCell(index, 'typeContrat', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.dureeContrat}
                        onChange={(e) => updateCell(index, 'dureeContrat', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.salaireBase}
                        onChange={(e) => updateCell(index, 'salaireBase', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <select
                        className="w-full border-none focus:outline-none text-[11px] bg-transparent"
                        value={row.tempsPartiel}
                        onChange={(e) => updateCell(index, 'tempsPartiel', e.target.value)}
                      >
                        <option value=""></option>
                        <option value="Oui">Oui</option>
                        <option value="Non">Non</option>
                      </select>
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.tauxHoraire}
                        onChange={(e) => updateCell(index, 'tauxHoraire', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.heuresContractuelles}
                        onChange={(e) => updateCell(index, 'heuresContractuelles', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.conventionCollective}
                        onChange={(e) => updateCell(index, 'conventionCollective', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.niveauCoef}
                        onChange={(e) => updateCell(index, 'niveauCoef', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.emploiEmbauche}
                        onChange={(e) => updateCell(index, 'emploiEmbauche', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.dernierContrat}
                        onChange={(e) => updateCell(index, 'dernierContrat', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.groupementEmployeurs}
                        onChange={(e) => updateCell(index, 'groupementEmployeurs', e.target.value)}
                      />
                    </td>
                    <td className="border px-1">
                      <input
                        type="text"
                        className="w-full border-none focus:outline-none text-[11px]"
                        value={row.observations}
                        onChange={(e) => updateCell(index, 'observations', e.target.value)}
                      />
                    </td>
                    <td className="border px-1 text-center">
                      <button
                        type="button"
                        className="text-red-600 hover:text-red-800 text-xs"
                        onClick={() => deleteRow(index)}
                      >
                        ✖
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-t border-gray-200">
            <div className="flex gap-3">
              <button
                type="button"
                onClick={addRow}
                className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md shadow-sm"
              >
                <span className="mr-2">＋</span> Ajouter un salarié
              </button>
              <button
                type="button"
                onClick={exportCSV}
                className="inline-flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-md shadow-sm"
              >
                <span className="mr-2">📄</span> Exporter en CSV
              </button>
            </div>
            <p className="text-xs text-gray-500">
              Astuce : utilisez l&apos;export CSV pour archiver le registre ou l&apos;int&eacute;grer &agrave; votre paie.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrePersonnel;
